

import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.8), rgba(59, 130, 246, 0.6)), url('https://public.readdy.ai/ai/img_res/5b73f2df7290c14d83e725438f5a664d.jpg')`
      }}
    >
      <div className="container mx-auto px-6 py-20">
        <div className="w-full max-w-4xl">
          <div className="text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              #1 Buyback Closings Company
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-blue-100 max-w-3xl">
              Our Company has mapped out the Buyback strategy for about 80% of all resorts clients own.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={scrollToContact}
                size="lg"
                className="bg-white text-blue-600 hover:bg-blue-50 border-2 border-white"
              >
                <i className="ri-phone-line mr-2"></i>
                Get Free Consultation
              </Button>
              <Button 
                onClick={scrollToServices}
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white hover:text-blue-600"
              >
                <i className="ri-arrow-right-line mr-2"></i>
                Explore Services
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={scrollToServices}
          className="text-white hover:text-blue-200 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
};

